<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        lg="12"
      >
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          :footer-props="footerProps"
          dense

          class="elevation-1"
          @current-items="fixRowColors()"
        >
          <template v-slot:item.active="{item}">
            <v-chip
              :color="item.active ? 'green' : 'red'"
              @click="item.active = item.active ? 0 : 1"
            >
              <v-icon
                size="small"
                color="white"
              >
                power_settings_new
              </v-icon>
            </v-chip>
          </template>
          <template v-slot:item.name="{item}">
            <v-chip
              v-if="item.name"
              small
            >
              {{ `${item.name + (item.dimension ? ' (' +item.dimension.name+')' : '')}` }}
            </v-chip>
          </template>
          <template v-slot:item.carrier_product_services="{item}">
            <v-menu
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <div
                  v-if="item.carrier_product_services && !$_.isEmpty(item.carrier_product_services)"
                >
                  <template v-for="(cps, index) in item.carrier_product_services">
                    <v-chip
                      v-if="index < 1"
                      :key="cps.slug"
                      small
                      v-on="on"
                    >
                      {{ cps.slug }}
                    </v-chip>
                    <v-chip
                      v-if="index === 1"
                      :key="cps.slug"
                      small
                      v-on="on"
                    >
                      <span>+{{ item.carrier_product_services.length - 1 }}</span>
                    </v-chip>
                  </template>
                </div>
                <div v-else>
                  <v-chip
                    :key="'none'"
                    small
                    v-on="on"
                  >
                    <span>{{ `${$t('none') + " " + $_.lowerCase($t('selected'))}` }}</span>
                  </v-chip>
                </div>
              </template>

              <v-col>
                <base-paginated-select
                  :selected="item.carrier_product_services"
                  endpoint="carrier-product-services"
                  :params="{scope: 'WithPanelAndAgreementInfo'}"
                  multiple
                  :label="$t('carrier_product_services')"
                  item-text="slug"
                  selected-item-text="slug"
                  @value-change="val => {
                    item.carrier_product_services = val;
                  }"
                />
              </v-col>
            </v-menu>
          </template>
          <template v-slot:item.products="{item}">
            <v-menu
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <div
                  v-on="on"
                >
                  <v-chip
                    v-if="item.products.length > 0"
                    :ref="`product_btn.${getIndex(item)}`"
                    small
                    v-on="on"
                  >
                    <span>{{ item.products.length }} {{ $t('selected') }}</span>
                  </v-chip>
                  <v-chip
                    v-else

                    :ref="`product_btn.${getIndex(item)}`"
                    small
                    v-on="on"
                  >
                    <span>{{ `${$t('none') + " " + $_.lowerCase($t('selected'))}` }}</span>
                  </v-chip>
                </div>
              </template>

              <v-col>
                <base-paginated-select
                  :ref="`product_input.${getIndex(item)}`"
                  :selected="item.products"
                  endpoint="products-select"

                  multiple
                  :label="$t('products')"
                  item-text="title"
                  selected-item-text="title"
                  :extra-params="{weight_from: item.weight_from, weight_to: item.weight_to}"
                  @blur="navigate(`sales_price`,getIndex(item))"
                  @value-change="val => {
                    item.products = val;
                  }"
                />
              </v-col>
            </v-menu>
          </template>
          <template v-slot:item.transitProduct="{ item }">
            <v-menu
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  v-if="item.transit_product"
                  small
                  v-on="on"
                >
                  {{ item.transit_product.title }}
                </v-chip>
                <v-chip
                  v-else
                  small
                  v-on="on"
                >
                  <span>{{ `${$t('none') + " " + $_.lowerCase($t('selected'))}` }}</span>
                </v-chip>
              </template>
              <v-col>
                <v-col cols="12">
                  <base-paginated-select
                    :selected="item.transit_product"
                    endpoint="transit"
                    :label="`${$t('transit')}`"
                    item-text="title"
                    selected-item-text="title"
                    @value-change="v => {
                      item.transit_product = v;
                      item.transit_product_id = v ? v.id : null;

                      doCalculatePrice(item)
                    }"
                  />
                </v-col>
              </v-col>
            </v-menu>
          </template>
          <template v-slot:item.linehaul_products="{item}">
            <v-menu
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <div
                  v-on="on"
                >
                  <v-chip
                    v-if="item.linehaul_products.length > 0"
                    small
                    v-on="on"
                  >
                    <span>{{ item.linehaul_products.length }} {{ $t('selected') }}</span>
                  </v-chip>
                  <v-chip
                    v-else
                    small
                    v-on="on"
                  >
                    <span>{{ `${$t('none') + " " + $_.lowerCase($t('selected'))}` }}</span>
                  </v-chip>
                </div>
              </template>

              <v-col>
                <base-paginated-select
                  :selected="item.linehaul_products"
                  endpoint="linehaul"
                  multiple
                  :label="$t('linehaul')"
                  item-text="title"
                  selected-item-text="title"
                  @value-change="val => {
                    item.linehaul_products = val;
                    doCalculatePrice(item)
                  }"
                />
              </v-col>
            </v-menu>
          </template>
          <template v-slot:item.geo="{ item }">
            <v-menu
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  small
                  v-on="on"
                >
                  {{ item.from_country.iso }} <v-icon>mdi-arrow-right</v-icon> {{ item.to_country.iso }}
                </v-chip>
              </template>
              <v-col>
                <base-paginated-select
                  :selected="item.from_country"
                  endpoint="countries"
                  :label="`${$t('from')} ${$t('country')}`"
                  item-text="full_name"
                  selected-item-text="full_name"
                  @value-change="v => item.from_country = v"
                />
                <base-paginated-select
                  :selected="item.to_country"
                  endpoint="countries"
                  :label="`${$t('to')} ${$t('country')}`"
                  item-text="full_name"
                  selected-item-text="full_name"
                  @value-change="v => item.to_country = v"
                />
              </v-col>
            </v-menu>
          </template>
          <template v-slot:item.weight="{ item }">
            <v-menu
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  small
                  v-on="on"
                >
                  {{ item.weight_from }}g <v-icon>mdi-arrow-right</v-icon> {{ item.weight_to }}g
                </v-chip>
              </template>
              <v-col>
                <v-text-field
                  v-model="item.weight_from"
                  :label="`${$t('weight')} ${$t('from')}`"
                  dense
                  type="number"
                  min="0.00"
                  step="0.01"
                  suffix="g"
                />
                <v-text-field
                  v-model="item.weight_to"
                  :label="`${$t('weight')} ${$t('to')}`"
                  dense
                  type="number"
                  min="0.00"
                  step="0.01"
                  suffix="g"
                />
              </v-col>
            </v-menu>
          </template>
          <template v-slot:item.dimension="{ item }">
            <v-menu
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  v-if="item.dimension"
                  small
                  v-on="on"
                >
                  {{ item.dimension.name }}
                </v-chip>
                <v-chip
                  v-else
                  small
                  v-on="on"
                >
                  <span>{{ `${$t('none') + " " + $_.lowerCase($t('selected'))}` }}</span>
                </v-chip>
              </template>
              <v-col>
                <v-col cols="12">
                  <base-paginated-select
                    :selected="item.dimension"
                    endpoint="dimensions"
                    :label="`${$t('dimensions')}`"
                    item-text="name"
                    selected-item-text="name"
                    @value-change="v => item.dimension = v"
                  />
                </v-col>
              </v-col>
            </v-menu>
          </template>
          <template v-slot:item.currency="{ item }">
            <v-menu
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  small
                  v-on="on"
                >
                  {{ item.currency.name }}
                </v-chip>
              </template>
              <v-col>
                <v-col cols="12">
                  <base-paginated-select
                    :selected="item.currency"
                    endpoint="currencies"
                    :label="`${$t('currency')}`"
                    item-text="full_name"
                    selected-item-text="full_name"
                    @value-change="v => {
                      item.currency = v
                      item.currency_id = v ? v.id : id;
                    }"
                  />
                </v-col>
              </v-col>
            </v-menu>
          </template>
          <template v-slot:item.cost="{item}">
            <div>{{ item.cost ? item.cost.toFixed(2) + " ,-" : '-' }}</div>
          </template>
          <template v-slot:item.sales_price="{item}">
            <v-text-field
              :ref="`sales_price.${getIndex(item)}`"
              v-model="item.sales_price"
              dense
              type="number"
              min="0.00"
              step="0.01"
              suffix=",-"
              @keydown.w="() => navigate(`sales_price`,getIndex(item)-1)"
              @keydown.s="() => navigate(`sales_price`,getIndex(item)+1)"
              @keydown.d="() => navigate(`sales_price_surcharge`,getIndex(item))"
              @keydown.a="() => navigate(`product_btn`,getIndex(item))"
            />
          </template>
          <template v-slot:item.sales_price_surcharge="{item}">
            <v-text-field
              :ref="`sales_price_surcharge.${getIndex(item)}`"
              v-model="item.sales_price_surcharge"
              dense
              type="number"
              min="0.00"
              step="0.01"
              suffix=",-"
              @keydown.w="() => navigate(`sales_price_surcharge`,getIndex(item)-1)"
              @keydown.s="() => navigate(`sales_price_surcharge`,getIndex(item)+1)"
              @keydown.d="() => navigate(`sales_price_percentage`,getIndex(item))"
              @keydown.a="() => navigate(`sales_price`,getIndex(item))"
            />
          </template>
          <template v-slot:item.sales_price_percentage="{item}">
            <v-text-field
              :ref="`sales_price_percentage.${getIndex(item)}`"
              v-model="item.sales_price_percentage"
              dense
              type="number"
              min="0.00"
              step="0.01"
              suffix="%"
              @keydown.w="() => navigate(`sales_price_percentage`,getIndex(item)-1)"
              @keydown.s="() => navigate(`sales_price_percentage`,getIndex(item)+1)"
              @keydown.d="() => navigate(`product_btn`,getIndex(item))"
              @keydown.a="() => navigate(`sales_price_surcharge`,getIndex(item))"
            />
          </template>
          <template v-slot:item.margin="{item}">
            <div>{{ item.margin ? item.margin.toFixed(2) + " ,-" : '-' }}</div>
          </template>
          <template v-slot:item.final_price="{item}">
            <div>{{ item.final_price ? item.final_price.toFixed(2) : '-' }}</div>
          </template>
          <template v-slot:item.has_insurance="{ item }">
            <v-chip
              v-if="!!item.has_insurance"
              color="green"
              text-color="white"
              @click="() => item.has_insurance = 0"
            >
              {{ $t('yes') }}
            </v-chip>
            <v-chip
              v-else
              color="red"
              text-color="white"
              @click="() => item.has_insurance = 1"
            >
              {{ $t('no') }}
            </v-chip>
          </template>
          <template v-slot:item.supports_app="{ item }">
            <v-chip
              v-if="!!item.supports_app"
              color="green"
              text-color="white"
              @click="() => item.supports_app = 0"
            >
              {{ $t('yes') }}
            </v-chip>
            <v-chip
              v-else
              color="red"
              text-color="white"
              @click="() => item.supports_app = 1"
            >
              {{ $t('no') }}
            </v-chip>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon
              v-if="(item.price_update && item.price_update.length) || item.priceable_type == 'price_update'"
              medium
              color="green"
              class="mr-2 update"
              @click="() => showPriceUpdate(item)"
            >
              mdi-update
            </v-icon>
            <v-icon
              medium
              color="orange"
              class="mr-2"
              @click="duplicatePrice(item)"
            >
              mdi-book-multiple
            </v-icon>
            <v-icon
              medium
              color="red"
              class="mr-2"
              @click="deletePrice(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:footer="{props}">
            <v-row
              justify="end"
              no-gutters=""
              style="border-top: thin solid rgba(0, 0, 0, 0.12)"
            >
              <v-btn
                class="mt-2"
                :disabled="editedIndexes.length == 0"
                right
                :color="editedIndexes.length == 0 ? 'grey' :'green'"
                @click="showActiveFromDialog = true"
              >
                <v-icon class="mr-3">
                  mdi-content-save
                </v-icon>
                {{ $t('save') }}
              </v-btn>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row
      justify="end"
    >
      <v-btn
        color="green"
        class="ml-auto mt-2"
        @click="dialog = true"
      >
        <v-icon class="mr-3">
          mdi-plus
        </v-icon>
        {{ $t('new') }}
      </v-btn>
    </v-row>
    <price-edit-dialog
      :visible="dialog"
      :calculate-price="doCalculatePrice"
      :entity="priceUpdate"
      @save="addPrice"
      @close="closeDialog"
      @delete="deletePrice"
    />
    <v-dialog
      v-model="showActiveFromDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <div class="text-body-1">
              Vælg venligst dato for hvornår ændringerne skal træde i kraft.
            </div>
            <v-row>
              <v-col
                cols="12"
              >
                <v-menu
                  v-model="menus.active_from"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="activeFrom"
                      :label="$t('valid_from')"
                      prepend-icon="event"
                      readonly
                      dense
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    :value="activeFrom"
                    first-day-of-week="1"
                    @input="val => activeFrom = val"
                  >
                    <v-spacer />

                    <v-btn
                      text
                      color="primary"
                      @click="() => {
                        menus.active_from = false
                      }"
                    >
                      {{ $t('ok') }}
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="showActiveFromDialog = false"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :disabled="!activeFrom"
            @click="updatePrices"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { ROLES, SUPERUSER, ADMIN, ALL } from '../../utils/constants'
  import { priceHeaders, calculatePrice } from '@/utils/helpers'
  import axios from 'axios'

  import hasher from 'object-hash'
  import List from '@/mixins/List'

  export default {
    mixins: [List],
    props: {
      context: {
        type: String,
        default: '',
      },
      pricegroup: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        name: 'price',
        initialHashes: {},
        editedIndexes: [],
        loading: true,
        dialog: false,
        options: { itemsPerPage: 10 },
        priceUpdate: null,
        showActiveFromDialog: false,
        activeFrom: '',
        menus: {
          active_from: false,
        },
      }
    },
    computed: {
      headers: function () {
        return priceHeaders
      },
      pricelinesWithTotal: function () {
        return this.$_.map(this.items, p => this.doCalculatePrice(p))
      },
    },
    watch: {
      pricelinesWithTotal: {
        deep: true,
        handler: function (val) {
          const edited = []
          this.$_.each(this.items, (item, index) => {
            const { final_price, margin, used_fields, calculation, cost, ...itemToUse } = item
            const hash = hasher(itemToUse)
            if (this.initialHashes[index].hash !== hash) edited.push(index)
          })
          this.editedIndexes = edited
        },
      },
    },
    mounted: function () {
      this.$store.commit('SET_HIDE_DRAWER', true)

      this.getDataFromApi()
    },

    methods: {
      getIndex: function (item) {
        return this.$_.findIndex(this.items, ['id', item.id])
      },
      doCalculatePrice: function (price) {
        return calculatePrice(price, this.pricegroup)
      },
      getDataFromApi: function () {
        if (this.cancelToken) { this.cancelToken.cancel('cancelled') }
        this.cancelToken = axios.CancelToken.source()

        this.loading = true

        this.$get(`/${this.context}/${this.$route.params.id}/prices`, { ...this.params, q: this.search, cancelToken: this.cancelToken.token }, { mutateLocation: false })
          .then(response => {
            this.items = response.data.data
            this.totalItems = response.data.total
            this.loading = false

            this.initialHashes = this.$_.map(response.data.data, (item, key) => ({ hash: hasher(item) }))

            this.loading = false
          })
          .catch((e) => {
            if (e !== 'cancelled') this.loading = false
          })
      },
      deletePrice (item) {
        if (!this.canDelete()) { return }

        const index = this.$_.findIndex(this.items, c => c.id === item.id)

        if (confirm(this.$t('confirm_delete', { type: this.$t(this.name).toLowerCase() }))) {
          this.$del(`/prices/${item.id}`, undefined).then(() => {
            if (index >= 0) { this.items.splice(index, 1) } else {
              this.closeDialog()
              this.fixRowColors()
              this.getDataFromApi()
            }
            this.$emit('update')
            this.closeDialog()

            this.$toast(`${this.$t(this.name)} ${this.$t('has_been_deleted')}`)
          })
        }
      },

      updatePrices () {
        if (this.$getUser().role < SUPERUSER.val) {
          let code = window.prompt("Spørg Thomas om kodeord");
          if (code == 'thomassigernej') {
            if (!this.editedIndexes.length || !this.canUpdate()) { return }

            const prices = []

            this.$_.each(this.items, (item, index) => {
              if (this.editedIndexes.includes(index)) {
                const products = this.$_.map(item.products, 'id')
                const carrier_product_services = this.$_.map(item.carrier_product_services, 'id')
                const linehaul_products = this.$_.map(item.linehaul_products, 'id')

                prices.push({ ...item, active_from: this.activeFrom, products, carrier_product_services, linehaul_products })
              }
            })

            this.$put(`/${this.context}/${this.$route.params.id}/prices`, { prices }).then(() => {
              this.activeFrom = ''
              this.showActiveFromDialog = false
              this.getDataFromApi()
              this.$emit('update')

              this.$toast(`${this.$t(this.name)} ${this.$t('saved_correctly')}`)
            })
          } else {
            window.alert("Forkert kodeord");
          }

        } else {
          if (!this.editedIndexes.length || !this.canUpdate()) { return }

          const prices = []

          this.$_.each(this.items, (item, index) => {
            if (this.editedIndexes.includes(index)) {
              const products = this.$_.map(item.products, 'id')
              const carrier_product_services = this.$_.map(item.carrier_product_services, 'id')
              const linehaul_products = this.$_.map(item.linehaul_products, 'id')

              prices.push({ ...item, active_from: this.activeFrom, products, carrier_product_services, linehaul_products })
            }
          })

          this.$put(`/${this.context}/${this.$route.params.id}/prices`, { prices }).then(() => {
            this.activeFrom = ''
            this.showActiveFromDialog = false
            this.getDataFromApi()
            this.$emit('update')

            this.$toast(`${this.$t(this.name)} ${this.$t('saved_correctly')}`)
          })
        }
      },
      updateList (prices) {
        this.pricelinesWithTotal = prices
      },
      duplicatePrice (item) {
        if (confirm(this.$t('confirm_duplicate', { type: this.$t(this.name).toLowerCase() }))) {
          const { id, ...price } = item
          this.addPrice({ item: price })
        }
      },
      addPrice ({ item }) {
        if (!this.canCreate()) { return }
        this.loading = true
        const products = this.$_.map(item.products, 'id')
        const carrier_product_services = this.$_.map(item.carrier_product_services, 'id')
        const linehaul_products = this.$_.map(item.linehaul_products, 'id')

        this.$post(`/${this.context}/${this.$route.params.id}/prices`, { price: { ...item, products, carrier_product_services, linehaul_products, active_from: this.activeFrom } }).then(() => {
          this.$toast(`${this.$t(this.name)} ${this.$t('saved_correctly')}`)
          this.getDataFromApi()
          this.$emit('update')
          this.closeDialog()
        })
      },
      closeDialog: function () {
        this.dialog = false
        this.priceUpdate = null
      },
      showPriceUpdate: function (p) {
        const isUpdate = p.priceable_type === 'price_update'
        const pu = isUpdate ? p : this.$_.get(p, 'price_update[0].price')
        const active_from = isUpdate ? this.$_.get(p, 'priceable.active_from') : this.$_.get(p, 'price_update[0].active_from')

        this.priceUpdate = { active_from, ...pu }
        this.dialog = true
      },
      navigate: function (ref, index) {
        if (!this.$refs[`${ref}.${index}`]) { return }

        if (ref === 'product_btn') {
          this.$refs[`product_btn.${index}`].$el.click()
          this.$refs[`product_input.${index}`].$refs.autocomplete.$refs.input.focus()

          setTimeout(() => {
            this.$refs[`product_input.${index}`].$refs.autocomplete.$refs.input.focus()
          }, 500)
        } else { this.$refs[`${ref}.${index}`].$refs.input.focus() }
      },
      fixRowColors: function () {
        setTimeout(() => {
          const rows = document.querySelectorAll('table tbody tr')
          rows.forEach(x => {
            const special = x.querySelector('button.update')
            if (special) {
              x.classList.add('update')
            }
          })
        }, 200)
      },
    },
  }
</script>

<style lang="sass">
tr.update
  background-color: rgba(255, 255, 0, 0.25)
tr.change
  background-color: rgba(255, 255, 0, 0.25)

</style>
